const state = {
  courseData: {},
};
const mutations = {
  SET_COURSE_DATA(state, val) {
    state.courseData = val;
  },
  CLEAR_COURSE_DATA(state) {
    state.courseData = {};
  }
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
